module.exports = __webpack_public_path__ + "static/media/money-check.f1b719da.svg";